import { Box, Stack, Typography } from '@mui/material';

interface ContractStatsProps {
    stats: {
        nrContracte: number;
        valContracte: number;
        nrContrExp: number;
        valContrExp: number;
        castigNet: number;
    };
    translations: {
        activeContracts: string;
        activeValue: string;
        expiredContracts: string;
        expiredValue: string;
        netProfit: string;
        currencyLei: string;
    };
}

const ContractStats = ({ stats, translations }: ContractStatsProps) => {
    return (
        <Stack direction="row" spacing={6} justifyContent="space-around">
            <Box textAlign="center">
                <Typography variant="caption" color="textSecondary">
                    {translations.activeContracts}
                </Typography>
                <Typography variant="h6" color="error" fontWeight="bold">
                    {stats.nrContracte}
                </Typography>
            </Box>
            <Box textAlign="center">
                <Typography variant="caption" color="textSecondary">
                    {translations.activeValue}
                </Typography>
                <Typography variant="h6" color="error" fontWeight="bold">
                    {stats.valContracte.toFixed(0)} {translations.currencyLei}
                </Typography>
            </Box>
            <Box textAlign="center">
                <Typography variant="caption" color="textSecondary">
                    {translations.expiredContracts}
                </Typography>
                <Typography variant="h6" color="error" fontWeight="bold">
                    {stats.nrContrExp}
                </Typography>
            </Box>
            <Box textAlign="center">
                <Typography variant="caption" color="textSecondary">
                    {translations.expiredValue}
                </Typography>
                <Typography variant="h6" color="error" fontWeight="bold">
                    {stats.valContrExp.toFixed(0)} {translations.currencyLei}
                </Typography>
            </Box>
            <Box textAlign="center">
                <Typography variant="caption" color="textSecondary">
                    {translations.netProfit}
                </Typography>
                <Typography variant="h6" color="error" fontWeight="bold">
                    {stats.castigNet.toFixed(0)} {translations.currencyLei}
                </Typography>
            </Box>
        </Stack>
    );
};

export default ContractStats;
